<template>
    <v-card color="primary-surface">
        <template #prepend>
            <v-row class="pa-2" align="center">
                <v-icon size="28" class="text-on-primary-surface">
                    mdi-account-circle
                </v-icon>
                <v-card-title class="ml-2 text-on-primary-surface">
                    {{ $t('loginView.bienvenido') }}
                </v-card-title>
            </v-row>
        </template>

        <v-card-text class="pb-0 text-on-primary-surface" style="font-size: 0.75rem">
            {{ $t('loginView.iniciaSesionParaObtenerMasBeneficios', { farmacia: farmacia.nombre }) }}
        </v-card-text>

        <v-card-actions class="">
            <v-btn
                class="px-4"
                height="30px"
                rounded="lg"
                variant="plain"
                color="on-primary-surface"
                style="font-size: 0.625rem"
                @click="$router.push({ name: 'Registro' })">
                {{ $t('loginRegistro.registrarse') }}
            </v-btn>
            <v-btn
                class="px-4"
                height="30px"
                rounded="lg"
                color="on-primary-surface"
                variant="flat"
                style="font-size: 0.625rem"
                @click="$router.push({ name: 'Login' })">
                {{ $t('loginRegistro.acceder') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        farmacia: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.text-shell {
    color: rgba(var(--v-theme-shell), 1);
}
</style>